module.exports = __webpack_public_path__ + "img/korea.a80a62f8.jpg";